import { createServerFn } from "@tanstack/react-start";
import { getServerCacheQueryClient } from "@/network/cache-query-client";
import { QueryKeysConfig } from "@/config/query-keys";
import { likePost as makeLikePostRequest } from "@/network/mutations/like-post";
import { getLikedPosts, setLikedPosts } from "@/persistence/liked-posts";
import type { TPost, TPostsFeed } from "@/network/typings";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  postId: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const listPost = createServerFn({ method: "POST" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema>) => v.parse(Schema, data))
  .handler(async ({ data: { postId } }) => {
    const likedPosts = await getLikedPosts();
    if (likedPosts.includes(postId)) {
      throw new Error("Лайк уже поставлен");
    }
    likedPosts.push(postId);
    setLikedPosts(likedPosts);
    await makeLikePostRequest({ postId });
    const cacheQueryClient = getServerCacheQueryClient();
    cacheQueryClient.setQueriesData<TPost>(
      {
        queryKey: [QueryKeysConfig.postBySlug],
      },
      (data) => {
        if (data?.id === postId) {
          data.likesCount += 1;
          return data;
        }
      },
    );
    for (const queryKey of [
      [QueryKeysConfig.rootPosts],
      [QueryKeysConfig.postsByTag],
      [QueryKeysConfig.searchPostsByTerm],
    ]) {
      cacheQueryClient.setQueriesData<TPostsFeed>(
        {
          queryKey,
        },
        (data) => {
          if (data) {
            for (const post of data.posts) {
              if (post.id === postId) {
                post.likesCount += 1;
              }
            }
          }
          return data;
        },
      );
    }
  });
